import React from 'react';
import { FiCalendar } from 'react-icons/fi';
import { HiOutlineLogout } from 'react-icons/hi';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import authService from '../../../../../services/authService';
import useAuth from '../../../../../hooks/account/useAuth';
import Action from './Action';
import useBusinesses from '../../../../../hooks/business/useBusinesses';
import { BusinessRole } from '../../../../../types/business';
import { wipeSelectedBusiness, wipeSelectedCommunity } from '../../../../../redux/slices/applicationSlice';

/**
 * Sidebar footer actions. Language + Feedback moved to the top bar;
 * keep community/business home + sign out here.
 */
export default function SettingsPanel() {
  const { t } = useTranslation();
  const auth = useAuth();
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const businesses = useBusinesses();

  const handleNavigateHome = () => {
    dispatch(wipeSelectedCommunity());
    dispatch(wipeSelectedBusiness());
    navigate('/');
  };

  const isBusiness = process.env.REACT_APP_APPLICATION_VERSION === 'BUSINESS';

  const hasMultipleBusinesses =
    isBusiness &&
    businesses &&
    businesses.filter(
      (business) =>
        business.dashboard &&
        (business.role === BusinessRole.MANAGER || business.role === BusinessRole.OWNER),
    ).length > 1;

  return (
    <>
      {location.pathname !== '/' && auth && (!isBusiness || hasMultipleBusinesses) && (
        <Action
          name={isBusiness ? t('page.businessOverview.title') : t('page.communityOverview.title')}
          textClassName="text-primary-900"
          icon={<FiCalendar className="h-5 w-5" />}
          onClick={handleNavigateHome}
        />
      )}
      {auth && (
        <Action
          name={t('auth.logout')}
          textClassName="text-primary-900"
          icon={<HiOutlineLogout className="h-5 w-5 text-primary-900" />}
          onClick={authService.logout}
        />
      )}
    </>
  );
}
